import { Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { InHouseTooltip } from "../InHouseTooltip/InHouseTooltip";

type Props = {
	onRemove: () => void;
	/**
	 * Whether this is THE trash icon the call-off walkthrough spotlights and presses — the first row whose
	 * removal opens a call-off with the replacement search. True on at most one row per page.
	 */
	isCallOffWalkthroughAnchor: boolean;
};

/** The Day view staff table's per-row trash icon. */
export const ShiftRemoveButton: FC<Props> = ({ onRemove, isCallOffWalkthroughAnchor }) => {
	const { t } = useTranslation();
	return (
		<InHouseTooltip title={t("remove")}>
			<IconButton
				size="small"
				onClick={(event) => {
					event.stopPropagation();
					onRemove();
				}}
				data-testid="day-schedule-shift-remove-button"
				data-annie-target={isCallOffWalkthroughAnchor ? "day-schedule-call-off-trigger" : undefined}
				sx={{ p: "2px", color: "primary.dark", "&:hover": { color: "error.main" } }}
			>
				<Delete sx={{ fontSize: "18px" }} />
			</IconButton>
		</InHouseTooltip>
	);
};
